var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38573 11.0323C8.18573 11.2748 7.81426 11.2748 7.61427 11.0323L4.34466 7.06814C4.07569 6.74202 4.30766 6.25 4.73039 6.25L11.2696 6.25C11.6923 6.25 11.9243 6.74202 11.6553 7.06814L8.38573 11.0323Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownWhite);
export default __webpack_public_path__ + "static/media/dropdown_white.f876b1d17e1c405f91a238d85eca262f.svg";
export { ForwardRef as ReactComponent };